module.exports = __webpack_public_path__ + "fonts/Poppins-100-devanagari1.267b250.woff2";